import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isContactEnrichment"];
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Caption } from 'breeze-intelligence-kit';
import { ObjectTypeLabel } from './EnrichableObjectTypesProvider/EnrichmentLabels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LiveEnrichmentDisclaimer = _ref => {
  let {
      children,
      isContactEnrichment = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!isContactEnrichment) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Caption, Object.assign({}, rest, {
    as: "div",
    role: "label",
    children: [children, /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "liveEnrichment.disclaimer",
      options: {
        objectType: /*#__PURE__*/_jsx(ObjectTypeLabel, {
          isCapitalized: false,
          type: "contact"
        })
      }
    })]
  }));
};